export const Messages = {
  GLOBAL: {
    TOKEN: {
      CLIPBOARD_SUCCESS: "Address copied to clipboard!",
    },
    ACCOUNT: {
      CREATED_SUCCESS: "Account created successfully.",
    },
    PROFILE: {
      SET_ROLE: "Set {profileName} as {role} successfully!",
      CREATE_SUCCESS: "Account created successfully",
      DESCRIPTION_EDIT_SUCCESS: "Updated profile description successfully.",
      INVENTORY_DISPLAY_SETTING_SUCCESS:
        "Updated profile inventory display setting successfully.",
      CLAIMED_KEY_SUCCESS: "Claimed key successfully",
    },
    CHAT: {
      CHAT_DISABLED: "Chat disabled.",
    },
  },
  FAMILY: {
    CAPO_REGIME: {
      MEMBER_UPDATED: "Member capo regime updated.",
    },
    BASIC: {
      CREATED_SUCCESS: "Family created successfully!",

      LEAVED_SUCCESS: "Leaved family successfully!",
      KICKED: "Kicked {name} from family",
      REJECTED_KICK: "Rejected kick member confirmation",

      IMAGE_SIZE_INVALID:
        "The logo's size should be less than {width}\u00D7{height}px.",
      BACK_SIZE_INVALID:
        "The background's size should be less than {width}\u00D7{height}px.",
      TELEGRAM_INVALID:
        "Please ensure that Telegram account name is entered correctly. ex: @username123",
      DISCORD_INVALID:
        "Please ensure that the Discord username is entered correctly. Example: https://discord.gg/abc123",
      TWITTER_INVALID:
        "Please ensure that Twitter account name is entered correctly. ex: @username123",

      LEAVE_FEE_INVALID: "Input family leave fee correctly.",
      UPDATE_LEAVE_FEE_SUCCESS: "Updated family leave fee.",
      UPDATE_LEAVE_FEE_REJECTED: "Rejected update family leave fee",

      SHARING_UPDATED: "Family sharing updated.",
      BRANDING_UPDATED: "Family branding updated.",
      PROMOTION_MONEY_UPDATED: "Family promotion money Updated",
    },
    INVITE: {
      JOINED_SUCCESS: "Joined family successfully!",
      REJECTED: "Rejected Invitation!",
      REJECTED_JOIN: "Rejected join family",
      INVITED: "Invited {name} to the family.",
    },
    STAKE: {
      STAKED_SUCCESS: "Staked to family bank successfully.",
      WITHDRAW_SUCCESS: "Successfully withdrew from the family bank. You received {bulletAmount} bullets.",
      GAME_CASH_DEPOSIT_SUCCESS: "Deposited in-game cash to the family bank.",
      GAME_CASH_WITHDRAW_SUCCESS: "Withdrew in-game cash from the family bank.",
      NATIVE_WITHDRAW_SUCCESS: "Withdrew native treasury from the family bank.",
      NATIVE_SWAP_SUCCESS: "Swapped family bank native treasury into in-game cash.",
    },
    INVENTORY: {
      TRANSFERRED_SUCCESS: "Item transferred successfully!",
      TRANSFERRED_REJECTED: "Rejected transfer item",
      NOT_ENOUGH: "You've got only {crateBalance} NFT Keys",
      NFT_TRANSFERRED_SUCCESS: "NFT Key transferred.",
      NFT_TRANSFERRED_REJECT: "Rejected transfer NFT Key.",
      OG_NFT_TRANSFERRED_SUCCESS: "OG NFT transferred",
      OG_NFT_TRANSFER_REJECTED: "Rejected transfer OG NFT.",
      DEPOSITED_NFT_SUCCESS: "Deposited NFT Key into the game.",
      DEPOSIT_NFT_REJECTED: "Rejected deposit NFT Key.",
      DEPOSITED_OG_NFT_SUCCESS: "Deposited OG NFT into the game.",
      DEPOSIT_OG_NFT_REJECTED: "Rejected deposit OG NFT.",
      WITHDRAW_NFT: "Withdraw NFT Key.",
      WITHDRAW_NFT_REJECTED: "Rejected withdraw NFT Key.",
      WITHDRAW_OG_NFT: "Withdraw OG NFT",
      WITHDRAW_OG_NFT_REJECTED: "Rejected withdraw OG NFT",
      UNWRAP_GAMEKEY_ITEM_SUCCESS: "Unwrapped Game Key Item.",
      UNWRAP_GAMEKEY_ITEM_REJECTED: "Rejected unwrapping Game Key Item.",
      UNWRAP_MAFIA_ITEM_SUCCESS: "Unwrapped MAFIA token Item.",
      UNWRAP_MAFIA_ITEM_REJECTED: "Rejected unwrapping MAFIA token Item.",
      UNWRAP_OG_NFT_SUCCESS: "Unwrapped OG NFT Item.",
      UNWRAP_OG_NFT_REJECTED: "Rejected unwrapping OG NFT Item.",
      UNWRAP_HELPER_CREDIT_SUCCESS: "Unwrapped Helper Credit Item.",
      UNWRAP_HELPER_CREDIT_REJECTED: "Rejected unwrapping Helper Credit Item.",
      UNWRAP_GI_CREDITS_SUCCESS: "Unwrapped GI Credits Item.",
      UNWRAP_GI_CREDITS_REJECTED: "Rejected unwrapping GI Credits Item.",
      UNWRAP_BULLET_SUCCESS: "Unwrapped Bullet Item.",
      UNWRAP_BULLET_REJECTED: "Rejected unwrapping Bullet Item.",
      UNWRAP_HEALTH_SUCCESS: "Unwrapped Health Item.",
      UNWRAP_HEALTH_REJECTED: "Rejected unwrapping Health Item.",
      UNWRAP_FTS_SUCCESS: "Unwrapped Founders Table Share Item.",
      UNWRAP_FTS_REJECTED: "Rejected unwrapping Founders Table Share Item.",
      BOUGHT_PREMIUM: "Bought premium.",
      BUY_PREMIUM_REJECTED: "Rejected buying premium.",
      PURCHASED_SUCCESS: "Successfully purchased",
      PURCHASED_REJECT: "Rejected buy NFT Key.",
      NOT_PURCHASE: "No Game Key to use, please purchase first.",
      OPENED_CRATE: "Opened a crate using NFT Key",
      DIVIDE_HEALTH_SUCCESS: "Divided health successfully.",
    },
  },
  MARKET: {
    BASIC: {
      LISTED_SUCCESS: "Listed item successfully.",
      LIST_REJECTED: "Rejected list item.",

      PURCHASED_ITEM_SUCCESS: "Purchased item successfully!",
      PURCHASING_ITEM_REJECTED: "Rejected purchase item.",
      MAKE_BID_SUCCESS: "Made a bid successfully!",
      CANCELED_LISTING_SUCCESS: "Canceled listing successfully!",
      CANCEL_LISTING_REJECTED: "Rejected cancel listing item.",
      FINISH_AUCTION_SUCCESS: "Finished an auction successfully!",
    },
  },
  VAULT: {
    BASIC: {
      CONVERT_SUCCESS: "Converted $MAFIA to {chain} and sent to vault.",
    },
  },
  EXCHANGE: {
    BASIC: {
      ITEM_SELECT_LIMIT: "You can select up to 5 items",
    },
    CONVERT: {
      ITEM_CONVERTED: "Item converted successfully.",
    },
    OTC: {
      TRADE_CREATED: "OTC trade created successfully.",
      TRADE_SUCCESSFUL: "OTC Trade success!",
      TRADE_CANCELED: "OTC trade cancelled successfully.",
    },
    DEPOSIT: {
      ADDED_NEW_LP: "Added new liquidity successfully",
      CANCELED_SUCCEED: "Successfully done",
      WITHDRAWN_SUCCEED: "Withdrawn MAFIA successfully",
    },
    SWAP: {
      SWAP_SUCCEED: "Successfully swapped {cash} Cash",
      VAULT_SPLITTER_SWAP_SUCCEED:
        "Successfully swapped $ {usdAmount} into Cash",
    },
  },

  DAO: {
    VOTE: {
      VOTED_SUCCESS: "Voted successfully",
    },

    CREATE: {
      CREATED_SUCCESS: "Created proposal successfully",
    },

    OPEN: {
      OPENED_SUCCESS: "Opened proposal successfully",
    },

    CLOSE: {
      CLOSED_SUCCESS: "Closed proposal successfully",
    },
  },

  ROULETTE: {
    LIQUIDITY: {
      REMOVED_SUCCESS: "Removed liquidity successfully",
      ADDED_SUCCESS: "Added liquidity successfully",
    },
    UPDATE_SETTINGS: {
      UPDATED_SUCCESS: "Updated settings successfully",
      MIN_BET_ERROR:
        "Minimum bet should be in range between {minBet} and {maxBet}",
      MAX_BET_ERROR:
        "Maximum bet should be in range between {minBet} and {maxBet}",
    },

    INITIALIZE_BET: {
      CLOSE_ERROR: "This roulette table is currently closed.",
      MIN_BET_ERROR: "Minimum sum of bets should be greater than {minBet}",
      MAX_BET_ERROR: "Maximum sum of bets should be less than {maxBet}",
      INITIALIZED_FAILED: "Failed to initialize bet",
      INITIALIZED_SUCCESS: "Initialized bet successfully",
      LOW_BALANCE: "You have low cash balance.",
      CITY_ERROR:
        "You are in another city, you can't bet on this roulette table.",
    },
  },

  SLOT: {
    LIQUIDITY: {
      REMOVED_SUCCESS: "Removed liquidity successfully",
      ADDED_SUCCESS: "Added liquidity successfully",
    },
    UPDATE_SETTINGS: {
      UPDATED_SUCCESS: "Updated settings successfully",
      MIN_BET_ERROR:
        "Minimum bet should be in range between {minBet} and {maxBet}",
      MAX_BET_ERROR:
        "Maximum bet should be in range between {minBet} and {maxBet}",
    },

    INITIALIZE_BET: {
      CLOSE_ERROR: "This slot machine is currently closed.",
      MIN_BET_ERROR: "Minimum bet should be greater than {minBet}",
      MAX_BET_ERROR: "Maximum bet should be less than {maxBet}",
      INITIALIZED_FAILED: "Failed to initialize bet",
      INITIALIZED_SUCCESS: "Initialized bet successfully",
      CITY_ERROR:
        "You are in another city, you can't bet on this slot machine.",
    },
  },

  TRAVEL: {
    START: {
      CASH_INSUFFICIENT: "Insufficient game cash, please get cash from market.",
      STARTED_SUCCESS: "Started travel successfully",
    },
    FINISH: {
      FINISHED_SUCCESS: "You have now arrived in {cityName}. Welcome!",
    },
  },

  JAIL: {
    BUY_OUT: {
      SUCCESS: "You have successfully bought out of jail!",
      SUCCESS_OTHER: "You bought {playerName} out of jail!",
    },
    BUST_OUT: {
      SUCCESS: "You have busted out {playerName} from jail!",
      WAIT_COOLDOWN: "You need to wait for the cooldown.",
    },
  },

  BOOZE: {
    CLAIM_PROFIT: {
      SUCCESS: "Claimed your profit successfully.",
      FAILED: "Failed to claim profit.",
    },

    BUY: {
      SUCCESS: "Purchased {boozeCount} {boozeType} successfully.",
      LIMIT_EXCEEDED: "You can't buy more than your limit",
      INSUFFICIENT_CASH: "Insufficient game cash, please get cash from market.",
      AMOUNT_CAN_NOT_ZERO: "The total amount should be greater than zero.",
    },

    SELL: {
      SUCCESS: "Sold {boozeCount} {boozeType} successfully.",
      LIMIT_EXCEEDED: "You can't sell more than your limit",
    },
  },

  NARCS: {
    CLAIM_PROFIT: {
      SUCCESS: "Claimed your profit successfully.",
      FAILED: "Failed to claim profit.",
    },

    BUY: {
      SUCCESS: "Purchased {narcsCount} {narcsType} successfully.",
      LIMIT_EXCEEDED: "You can't buy more than your limit",
      INSUFFICIENT_CASH: "Insufficient game cash, please get cash from market.",
    },

    SELL: {
      SUCCESS: "Sold {narcsCount} {narcsType} successfully.",
      LIMIT_EXCEEDED: "You can't sell more than your limit",
    },
  },

  KILL_SKILL: {
    TRAIN: {
      REQUESTED: "Training requested. Waiting for the next blocks...",
      PENDING: "You have a pending training request. Finishing it now...",
      SUCCESS: "Trained kill skill successfully.",
      INSUFFICIENT_CASH: "Insufficient game cash, please get cash from market",
      FAILED: "Failed to train kill skill.",
    },
  },

  BACKFIRE: {
    BULLET_AMOUNT_INVALID: "Enter a valid bullet amount to shoot.",
    SAVE_SUCCESS: "Backfire settings saved.",
    SAVE_FAILED: "Failed to save backfire settings. Please try again.",
  },

  KILL_INITIATION: {
    TARGET_REQUIRED: "Please enter a victim name or wallet address.",
    TARGET_INVALID: "Target not found. Select a valid profile or wallet address.",
    BULLETS_INVALID: "Enter a valid bullet amount to spend on this attack.",
    INSUFFICIENT_BULLETS: "You don't have enough bullets for this attack.",
    CANNOT_ATTACK_SELF: "You cannot target yourself.",
    TARGET_IN_SAFEHOUSE:
      "This target is in the safehouse and cannot be attacked.",
    TARGET_NOT_FOUND_BY_DETECTIVE:
      "This target has not been located. Hire detectives at the Detective Agency and reveal their location before initiating a kill.",
    TARGET_WRONG_CITY:
      "Your target is in {city}. Travel to the same city before initiating a kill.",
    TARGET_DETECTIVE_EXPIRED:
      "Your window to kill this target has expired. Hire detectives again to find them.",
    NO_WEAPON_EQUIPPED:
      "You have no weapon equipped in {city}. Equip a weapon for this city before initiating a kill.",
    RANK_NOT_ACTIVE:
      "Your rank is not activated. Activate your rank on the Rank Activation page before initiating a kill.",
    PREVIEW_ONLY:
      "Kill initiation is currently available as a frontend preview. No on-chain transaction will be submitted.",
    ATTACK_ATTEMPTED:
      "Attack initiated on-chain. Outcome processing will follow in a later update.",
    BULLET_AMOUNT_OUT_OF_RANGE:
      "Bullet amount is outside the allowed attack range.",
    VICTIM_INACTIVE:
      "This target is inactive (dead or jailed) and cannot be attacked.",
    RANK_DIFFERENCE_OUT_OF_RANGE:
      "Rank difference is too large to attack this target. You can only attack players within {max} ranks of your level.",
    CITY_MISMATCH:
      "You must be in the same city as your target to attack.",
    DETECTIVE_LOCK_EXPIRED:
      "Your detective lock on this target has expired. Hire detectives again.",
  },

  KILL_OUTCOME: {
    REWARD_CLAIMED: "Kill rewards claimed successfully.",
    REWARD_CLAIM_FAILED: "Failed to claim kill rewards. Please try again.",
    DRAIN_BATCH_COMPLETE:
      "Drain batch complete. Click again to drain the next batch until finished.",
    KILL_ID_NOT_FOUND:
      "Could not find an on-chain kill record for this battle. Try again after the kill transaction confirms.",
    KILL_NOT_FOUND:
      "No kill found for this ID. Check the link and try again.",
    REGISTRY_NOT_CONFIGURED:
      "Kill reward claiming is not available on this network yet.",
  },

  REBIRTH: {
    OPTION_REQUIRED: "Select a rebirth option to continue.",
    OPTION_DISABLED: "This rebirth option is currently disabled.",
    INSUFFICIENT_CASH:
      "Insufficient game cash for this rebirth. Deposit or earn more cash first.",
    SUCCESS: "Welcome back — you are alive again.",
  },

  GARAGE: {
    CAR_DEPOSIT: {
      SUCCESS: "Deposited car successfully.",
      NO_CAR_ITEMS: "You don't have any car items to deposit.",
    },
  },

  HELPER_BOT: {
    NOT_ENOUGH_CREDITS: "Not enough credits to start the bot.",
    CRIME_BOT: {
      STARTED_SUCCESS: "Crime bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
    },
    CAR_BOT: {
      STARTED_SUCCESS: "Car bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
    },
    KS_BOT: {
      STARTED_SUCCESS: "Kill skill bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
    },
    BOOZE_BOT: {
      STARTED_SUCCESS: "Booze bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
      UNABLE_START: "You rank level must be above Cloak",
    },
    NARCS_BOT: {
      STARTED_SUCCESS: "Narcs bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
      UNABLE_START: "You rank level must be above Locksmith",
    },
    BULLET_DEALER_BOT: {
      STARTED_SUCCESS: "Bullet dealer bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
      INSUFFICIENT_CASH: "Insufficient game cash, please get cash from market.",
    },
    RACE_XP_BOT: {
      STARTED_SUCCESS: "Race XP bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
    },
    BUST_OUT_XP_BOT: {
      STARTED_SUCCESS: "Bust out XP bot started successfully.",
      WITHDRAW_SUCCESS: "Withdrew rewards successfully.",
    },
  },

  BULLET_FACTORY: {
    BUY_BULLET: {
      SUCCESS: "Bought bullets successfully.",
      FAILED: "Failed to buy bullets.",
    },
    CLAIM_PROFIT: {
      SUCCESS: "Claimed your profit successfully.",
      FAILED: "Failed to claim profit.",
    },
    REPRODUCE_BULLET: {
      SUCCESS: "Reproduced bullets successfully.",
    },
  },

  XPMarket: {
    List: {
      NOT_SELECT_TYPE: "Please select XP type",
      NOT_SELECT_TOKEN: "Please select token",
      NOT_SELECT_AMOUNT: "Please input unit start amount",
      NOT_SELECT_DURATION: "Please select duration",
      NOT_SELECT_CONFIRM: "Please confirm the terms and conditions",
    },
    Bid: {
      SUCCESS: "Bid successfully.",
      FAILED: "Failed to bid.",
    },
    Cancel: {
      AlreadyBid: "You can’t cancel it—someone’s already placed a bid.",
    },
  },

  HOSPITAL: {
    BUY_HEALTH: {
      SUCCESS: "Bought health successfully.",
      FAILED: "Failed to buy health.",
      INSUFFICIENT_CASH: "Insufficient game cash, please get cash from market.",
      INSUFFICIENT_HEALTH: "You don't have enough health to buy.",
    },
    CLAIM_PROFIT: {
      SUCCESS: "Claimed your profit successfully.",
      FAILED: "Failed to claim profit.",
    },
    REPRODUCE_HEALTH: {
      SUCCESS: "Reproduced health successfully.",
      FAILED: "Failed to reproduce health.",
    },
  },
  RACING: {
    CREATE: {
      SUCCESS: "Created racing lobby successfully.",
      FAILED: "Failed to create racing lobby.",
      ALREADY_ACTIVE_LOBBY: "You already have an active racing lobby.",
      HEALTH: "You need min. 251 health to race",
    },
    JOIN: {
      NOT_IN_SAME_CITY: "The race has been created in another city. You can't join this race.",
    },
    CANCEL: {
      SUCCESS: "Cancelled racing lobby successfully.",
    },
  },
  ORGANIZED_CRIME: {
    HEALTH: "You need min 300 health to create or join an organized crime lobby",
    MAX_CASH: "Max cash amount to create an organized crime lobby is 1,500,000",
    TRAVEL_DISABLED: "You can't travel while you are in an organized crime lobby",
  },
  PERK: {
    OPENED_PERK_BOX: "Opened perk box successfully.",
    ACTIVATED_PERK: "Activated perk successfully.",
    CANCEL_PERK_SUCCESS: "Cancelled perk successfully.",
    UNLOCK_STAKE_SUCCESS: "Unlocked stake successfully.",
    SPLIT_PERK_BOX_SUCCESS: "Split perk box successfully.",
  },

  JACKPOT: {
    ENTERED_SUCCESS: "Successfully entered jackpot!",
    ENTERED_WITH_PERK_BOXES_SUCCESS:
      "Successfully entered jackpot with perk boxes!",
    BET_LIMITS_UPDATED_SUCCESS: "Bet limits updated successfully!",
    OWNER_TRANSFER_INITIATED: "Owner transfer initiated successfully!",
  },

  BODYGUARD: {
    UNWRAP_BODYGUARD_SUCCESS: "Unwrapped Bodyguard Item.",
    TRAINING: {
      SUCCESS: "Trained bodyguard successfully.",
      INSUFFICIENT_BALANCE: "Insufficient game cash balance for training.",
      NO_AVAILABLE_SLOTS:
        "All training slots are currently busy. Please wait for training to complete.",
    },
  },

  GICREDIT: {
    BUY_SUCCESS: "Credits purchased successfully",
    REQUEST_SUCCESS:
      "Game Intelligence request sent, please check out your inbox.",
  },
  PREMIUM: {
    SUBSCRIBE_SUCCESS: "Subscribed successfully.",
  },
  MYSTERY_BOX: {
    NO_MYSTERY_BOX: "You don't have any mystery box.",
    OPENED_MYSTERY_BOX: "Opened mystery box successfully.",
  },
};

export type MessageType = typeof Messages;
